import LocationsTooltip from "./LocationsTooltip";
import "./PackageCard.css";

const PackageCard = ({
    pkg,
    hoveredCardId,
    setHoveredCardId,
    hoveredLocation,
    handleLocationHover,
    handleLocationLeave,
    locations,
    moreInfoText = "(Más Información)",
    registerText = "Registrarme",
    registerButtonProps = {},
    isRegisterButton = false
}) => {
    return (
        <div
            className="card h-100 course shadow-sm text-center package-card-component"
            onMouseEnter={() => setHoveredCardId(pkg.id)}
            onMouseLeave={() => setHoveredCardId(null)}
            style={{
                cursor: "pointer",
                border:
                    hoveredCardId === pkg.id
                        ? "1px solid var(--metro-yellow)"
                        : "1px solid rgba(255, 255, 255, 0.1)",
                transition: "all 0.3s ease-in-out",
            }}
        >
            <div className="course-header text-uppercase">
                {pkg.titleLines.map((line, idx) => (
                    <div key={idx} className="fw-bold">
                        {line}
                    </div>
                ))}
            </div>
            {pkg.price && (
                <div
                    className="course-price fw-bold"
                    style={
                        hoveredCardId === pkg.id
                            ? { filter: "brightness(0.8)", background: "#2f2f2f" }
                            : {}
                    }
                >
                    {pkg.price}
                </div>
            )}
            <div className="card-body d-flex flex-column">
                <div className="card-text flex-grow-1 mb-3 text-start">
                    {pkg.description}
                </div>

                {pkg.infoLink && (
                    <div className="mb-3">
                        <a href={pkg.infoLink} className="link-info-custom fw-semibold">
                            {moreInfoText}
                        </a>
                    </div>
                )}

                {pkg.locationLink && (
                    <div className="mb-3">
                        <LocationsTooltip
                            show={hoveredLocation === pkg.id}
                            onMouseEnter={() => handleLocationHover(pkg.id)}
                            onMouseLeave={handleLocationLeave}
                            locations={locations}
                            lang="es"
                        />
                    </div>
                )}

                <div className="d-grid mt-auto">
                    {isRegisterButton ? (
                        <button
                            className="btn metro-btn-primary fw-bold text-uppercase"
                            {...registerButtonProps}
                        >
                            {registerText}
                        </button>
                    ) : (
                        <a
                            href={pkg.registerLink}
                            target={registerText === "More Info" ? "_self" : "_blank"}
                            rel="noopener noreferrer"
                            className="btn metro-btn-primary fw-bold text-uppercase"
                        >
                            {registerText}
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PackageCard;
